export const content = {
  GR: {
    HEADER: "Καλώς ήρθατε! Χαίρομαι που θέλετε να με γνωρίσετε.",

    INTRO:
      "Ονομάζομαι Θεργιάκης Ευτύχιος, είμαι software engineer, έχω γενηθεί, μεγαλώσει και ζω στο Ηράκλειο Κρήτης. Είμαι εφευρετικός, αυτοδίδακτος, εργατικός και μαθαίνω γρήγορα. Ευέλικτος και ομαδικός. Ψάχνω μία θέση στον τομέα ανάπτυξης εφαρμογών όπου οι δεξιότητες μου θα προσφέρουν στο τελικό αποτέλεσμα, καθώς θα μου επιτρέπει να επεκτείνω τις γνώσεις μου στον τομέα του software και να εμβαθύνω περισσότερο στον τομέα του ΑΙ. Περισσότερα στην σελίδα",

    ABOUT_ME_TAG: "/about.",

    PROFILE:
      "Software engineer, AI enthusiast, μερικές φορές geek. Μου αρέσουν οι άνθρωποι που χαμογελούν και έχουν χιούμορ, τα παζλς και οι γρίφοι και πιστεύω ότι ο προγραμματισμός ειναι ένας πιό κομψός τρόπος να λύνεις προβλήματα. Με γοητεύει το πως μια γραμμή κώδικα μπορεί να αλλάξει την καθημερινότητα κάποιου. Στον ελεύθερο μου χρόνο μου αρέσει να γράφω ηλεκτρονική μουσική.",

    WORK_EXP: [
      {
        title: "Younet",
        period: {
          text: "Οκτώβριος 2025 - Σήμερα",
          date: {
            start: "10/25",
            end: "Σήμερα",
          },
        },
        hasRecLetter: false,
        description:
          "Σχεδιασμός, ανάπτυξη και συντήρηση πολλαπλών web εφαρμογών και εσωτερικών εργαλείων σε production περιβάλλον, καλύπτοντας διαφορετικά business needs και ροές χρηστών. Ανάληψη πρωτοβουλιών σε backend αρχιτεκτονική, integrations μεταξύ συστημάτων και διαχείριση δεδομένων, με έμφαση στην απόδοση, αξιοπιστία και επεκτασιμότητα. Εργασία σε σύνθετα queries, data flows και βελτιστοποίηση υπαρχουσών λύσεων, καθώς και ενεργή συμβολή στη συνολική τεχνική κατεύθυνση και εξέλιξη των εφαρμογών.",
      },
      {
        title: "Margera",
        period: {
          text: "Ιανουάριος 2025 - Ιούλιος 2025",
          date: {
            start: "01/25",
            end: "06/25",
          },
        },
        hasRecLetter: true,
        description:
          "Ανάπτυξη ολοκληρωμένης πλατφόρμας παρακολούθησης trends με χρήση Τεχνητής Νοημοσύνης, LLMs και προηγμένων metrics, αξιοποιώντας τεχνολογίες όπως React, Django, SQL και BigQuery. Ενασχόληση με data warehousing και reporting, καθώς και συντήρηση σύνθετων ETL pipelines σε SQL. Δημιουργία και βελτιστοποίηση πολύπλοκων queries και procedures για την εξαγωγή, ανάλυση και διαχείριση δεδομένων μεγάλης κλίμακας.",
      },
      {
        title: "Squaredev",
        period: {
          text: "Μάρτιος 2022 - Ιανουάριος 2025 · 2 χρόνια 11 μήνες",
          date: {
            start: "03/22",
            end: "12/24",
          },
        },
        hasRecLetter: false,
        description:
          "Συνεργάστηκα ως εξωτερικός σύμβουλος στην Intrasoft για την πλατφόρμα BOIP, που αφορά την καταχώριση δικαιωμάτων οργανισμών της ΕΕ, με βασικό ρόλο στο frontend. Είχα καθοριστική συμβολή σε όλα τα στάδια ανάπτυξης του “Anty”, του recommendation system και βασικού προϊόντος της Squaredev. Συμμετείχα επίσης στο ευρωπαϊκό έργο Sunrise, για την πρόβλεψη ζήτησης πόρων σε τομείς όπως το νερό και η υγεία, από την ανάπτυξη βιβλιοθηκών μέχρι τα deployments και το Kubernetes. Τέλος, ηγήθηκα της ανάπτυξης πλατφόρμας penetration testing για LLMs σε συνεργασία με την AIandMe, χρησιμοποιώντας τεχνολογίες όπως multithreading, websockets, σχεσιακές βάσεις, Azure και frontend ανάπτυξη με Next.js.",
      },
      {
        title: "Resitech LTD",
        period: {
          text: "Απρίλιος 2021 - Μάρτιος 2022 · 1 χρόνος",
          date: { start: "04/21", end: "03/22" },
        },
        hasRecLetter: false,
        description:
          "Ανάπτυξη της πλατφόρμας της Resitech LTD για παρουσίαση NLP και Real Estate δεδομένων σε μορφή γραφημάτων με χρήση τεχνολογιών όπως React.js, Node.js, και Mongo DB σε βάση δεδομένων, καθώς και συλλογή δεδομένων από σελίδες real estate (web scraping). Επιπλέον η ανάπτυξη ενός μικρού ισχυρού interactive εργαλείου για συλλογή feedback πελατών καθώς και αναφοράς προβλημάτων μέσα από αυτό.",
      },
    ],

    EDUCATION: "ΤΕΙ Ηρακλείου – Τμήμα Εφαρμοσμένης Πληροφορικής και Πολυμέσων (2013-2019)",

    LANG_ARRAY: ["Ελληνικά", "Αγγλικά", "Λίγα Γαλλικά και Ιταλικά"],
    SOFT_SKILLS: [
      "Ικανότητες αναλυτικής σκέψης και επίλυσης προβλημάτων",
      "Τεχνικές βελτιστοποίησης απόδοσης",
      "Δυνατές δεξιότητες εντοπισμού και επίλυσης σφαλμάτων",
      "Άμεση και ξεκάθαρη επικοινωνία",
      "Διάθεση για συνεργασία",
    ],

    CONTACT_PROMPT: "Εάν έχω ξεχάσει να αναφέρω κάτι μπορείτε πάντα να επικοινωνήσετε μαζί μου με τους εξής τρόπους:",

    DOWNLOAD_CV: "Kατεβάστε το βιογραφικό μου",

    PINNED: {
      iamAI: {
        TITLE: "iamAI",
        DESCRIPTION: "Ένα έξυπνο chatbot που απαντάει παντός τύπου ερωτήσεις, καθώς είναι και διαθέσιμο μέσω API.",
      },
    },

    AND: " και ",
    PROJECTS: [
      {
        name: "Nemeseas",
        duration: "Φεβρουάριος 2026 - Σήμερα",
        company: "Younet",
        description:
          "Σχεδιασμός και ανάπτυξη του backend για ένα ολοκληρωμένο σύστημα κρατήσεων εστιατορίων (Nemeseas), με πλήρη ευθύνη αρχιτεκτονικής και υλοποίησης. Δημιουργία scalable και reusable backend σε Node.js (TypeScript), με έμφαση στην απόδοση και την εμπειρία ανάπτυξης. Υλοποίηση caching, mailing systems, schedulers, task queues και προηγμένων REST APIs. Ενσωμάτωση πληρωμών και υποστήριξη frontend. Δημιουργία reusable boilerplate για αύξηση της παραγωγικότητας και συντηρησιμότητας του κώδικα.",
        skills: [
          "Node.js",
          "TypeScript",
          "Architecture",
          "REST APIs",
          "Caching",
          "Task Queues",
          "Payments",
          "System Design",
        ],
      },
      {
        name: "Cloudo",
        duration: "Μάρτιος 2026",
        company: "Younet",
        description:
          "Συμμετοχή στον σχεδιασμό και την ανάπτυξη του Cloudo, ενός private cloud συστήματος διαχείρισης αρχείων για την Ορθόδοξο Ακαδημία Κρήτης (ΟΑΚ). Εστίαση στην ασφαλή αποθήκευση και ψηφιοποίηση πολύτιμου αρχειακού υλικού. Υλοποίηση λειτουργιών διαχείρισης αρχείων, ρόλων και δικαιωμάτων πρόσβασης, συμβάλλοντας στη διατήρηση και ψηφιακή οργάνωση σημαντικών δεδομένων.",
        skills: [
          "Full-Stack Development",
          "System Design",
          "Access Control",
          "File Management",
          "TypeScript",
          "Express",
          "Next.js",
        ],
      },
      {
        name: "CampusHub",
        duration: "Φεβρουάριος 2026",
        company: "Younet",
        description:
          "Συμμετοχή στην ταχεία ανάπτυξη της πλατφόρμας πρακτικής άσκησης CampusHub, με στόχο τη μείωση της γραφειοκρατίας μεταξύ φοιτητών και εργοδοτών. Εργασία υπό αυστηρά deadlines με υλοποίηση νέων λειτουργιών και επίλυση κρίσιμων προβλημάτων σε frontend και backend. Συμβολή στη σταθεροποίηση της πλατφόρμας πριν την παράδοση και βελτίωση της συνολικής εμπειρίας χρήστη.",
        skills: ["Full-Stack Development", "React", "Node.js", "Bug Fixing", "Rapid Delivery", "Debugging"],
      },
      {
        name: "Idealink (Κοινωνικό Δίκτυο ΠΑΔΑ)",
        duration: "Οκτώβριος 2025 - Φεβρουάριος 2026",
        company: "Younet",
        description:
          "Ενασχόληση με μεγάλη πλατφόρμα κοινωνικής δικτύωσης (Idealink) για το Πανεπιστήμιο Δυτικής Αττικής, με έμφαση στη βελτιστοποίηση απόδοσης και την επεκτασιμότητα. Εντοπισμός και επίλυση κρίσιμων bottlenecks στη βάση δεδομένων, βελτιώνοντας σημαντικά την απόκριση του συστήματος. Βελτιστοποίηση και επέκταση υπαρχόντων backend components σε αρχιτεκτονική microservices με Node.js, με υλοποίηση νέων λειτουργιών και ανασχεδιασμό κρίσιμων μερών του συστήματος, όπως το database driver, για μεγαλύτερη επαναχρησιμοποίηση και βελτίωση της αποδοτικότητας της ομάδας. Υλοποίηση νέων λειτουργιών που επιτάχυναν την ανάπτυξη και συμβολή σε frontend bug fixing για σταθερότητα της πλατφόρμας.",
        skills: ["Node.js", "Microservices", "Performance Optimization", "Database Tuning", "Refactoring", "Debugging"],
      },
      {
        name: "TV Attribution",
        duration: "Ιούλιος 2025 - Ιούλιος 2025",
        company: "Margera",
        description:
          "Υλοποίησα ένα σύστημα που στοχεύει στοιχεία της πλατφόρμας, εξάγει το περιεχόμενό τους σε αρχεία CSV και τροφοδοτεί τα δεδομένα στο Gemini για τη δημιουργία συστάσεων. Οι συστάσεις εμφανίζονταν μέσω ειδικού εικονιδίου στο UI και ενσωματώνονταν απευθείας στα εκτυπώσιμα αποτελέσματα της πλατφόρμας, βελτιώνοντας τις επιχειρηματικές γνώσεις και τη χρηστικότητα για τον πελάτη.",
        skills: ["Python", "Google Cloud", "Gemini", "Data Extraction", "Prompt Engineering"],
      },
      {
        name: "Philip Morris International Consulting",
        duration: "Mάρτιος 2025 - Ιούλιος 2025",
        company: "Margera",
        description:
          "Ενασχόληση με data warehousing και reporting, καθώς και συντήρηση σύνθετων ETL διαδικασιών σε SQL για την αυτοματοποίηση ροών δεδομένων. Ανάπτυξη και βελτιστοποίηση πολύπλοκων queries και procedures για εξαγωγή, ανάλυση και διαχείριση δεδομένων σε μεγάλο όγκο.",
        skills: ["SQL", "BigQuery", "Google Cloud", "Proceedures"],
      },
      {
        name: "Culture Mapper (Publicis Groupe)",
        duration: "Ιανουάριος 2025 - Μάρτιος 2025",
        company: "Margera",
        description:
          "Ανάπτυξη πλατφόρμας παρακολούθησης trends με AI, LLMs και embeddings για την Publicis Groupe. Περιλάμβανε scraping και συλλογή δεδομένων (π.χ. TikTok, YouTube), ανάλυση και clustering με embeddings, καθώς και παραγωγή περιλήψεων και metrics μέσω LLMs. Υλοποίηση σε React, Django και BigQuery, με σύνθετα SQL ETLs για επεξεργασία και παρουσίαση δεδομένων.",
        skills: [
          "BigQuery",
          "Google Cloud",
          "OpenAI platform",
          "Embeddings",
          "SQL",
          "Django",
          "Python",
          "React",
          "Prompt Engineering",
        ],
      },
      {
        name: "AIandMe Platform",
        duration: "Σεπ 2024 - Δεκέμβριος 2024",
        company: "Squaredev",
        description:
          "Σχεδίαση και υλοποίηση backend αξιολόγησης LLM agent από το μηδέν, με δυνατότητα real-time ελέγχου των prompts πριν φτάσουν στον agent. Χρησιμοποιήθηκαν SQL Server, CosmosDB, Azure Durable Functions, Azure Storage και multithreading, με middleware υψηλής απόδοσης για ζωντανή αξιολόγηση και άμεση λήψη αποφάσεων σε μεγάλη κλίμακα.",
        skills: [
          "Python (Programming Language)",
          "Microsoft SQL Server",
          "Microsoft Azure",
          "Multithreading",
          "Storage Management",
          "Azure Cosmos DB",
          "Azure Functions",
          "Azure Durable Functions",
          "Prompt Engineering",
        ],
      },
      {
        name: "AI Prognosis",
        duration: "Σεπ 2024 - Σεπ 2024",
        company: "Squaredev",
        description:
          "Ανάπτυξη scheduler υψηλής απόδοσης για το έργο AI Prognosis με χρήση του Celery, για αξιόπιστη και επεκτάσιμη αποστολή ειδοποιήσεων σε πραγματικό χρόνο. Σχεδιασμένος με έμφαση στην ακρίβεια και την αποδοτικότητα, εξυπηρετώντας τη συνεχή επικοινωνία με αυξανόμενο αριθμό χρηστών.",
        skills: ["Python (Programming Language)", "Celery"],
      },
      {
        name: "Sunrise EU",
        duration: "Νοε 2023 - Σεπ 2024",
        company: "Squaredev",
        description:
          "Ανάπτυξη εργαλείου πρόβλεψης ζήτησης για πολλαπλούς δημόσιους τομείς, με στόχο την υποστήριξη της λήψης αποφάσεων σε θέματα διαχείρισης πόρων. Αυτοματοποιήθηκε η ανάπτυξη διαφορετικών μοντέλων μηχανικής μάθησης προσαρμοσμένων σε τομείς όπως το νερό, η υγεία και η ενέργεια, προσφέροντας επεκτάσιμη και βασισμένη στα δεδομένα πληροφόρηση.",
        skills: [
          "Python (Programming Language)",
          "ElasticSearch",
          "Keycloak",
          "MinIO Object Storage Suite",
          "Bash",
          "GitHub Actions",
          "Kubernetes",
          "Docker Products",
          "Continuous Integration and Continuous Delivery (CI/CD)",
          "ArgoCD",
        ],
        additional_info:
          "timepulse: Μια μικρή βιβλιοθήκη που φτιάξαμε για την ενσωμάτωση διαφορετικών μοντέλων στο έργο Sunrise",
      },
      {
        name: "UpHellas",
        duration: "Ιουλ 2023 - Ιουλ 2023",
        company: "Squaredev",
        description:
          "Βελτιστοποίηση του εργαλείου MLTool για την αποδοτική επίλυση του σύνθετου προβλήματος συσχέτισης εγγραφών (record linkage), με χρήση παραλληλοποίησης σε Python. Έμφαση στην απόδοση και την κλιμάκωση μέσω τεχνικών multiprocessing για ταχύτερη επεξεργασία μεγάλων συνόλων δεδομένων.",
        skills: ["Parallel Processing", "Multithreading", "Python (Programming Language)", "Record Linkage"],
      },
      {
        name: "Anty",
        duration: "Μαϊ 2022 - Ιαν 2023",
        company: "Squaredev",
        description:
          "Σχεδίαση και ανάπτυξη συστήματος προτάσεων υψηλής απόδοσης και μεγάλης κλίμακας, το οποίο υποστήριζε πολλαπλά e-pharmacies σε διαφορετικές πλατφόρμες. Το σύστημα διαχειριζόταν μεγάλο ταυτόχρονο φορτίο από διαφορετικά καταστήματα, προσφέροντας εξατομικευμένες προτάσεις με υψηλή ταχύτητα και αρμονική ενσωμάτωση σε διαφορετικά περιβάλλοντα.",
        skills: [
          "Python (Programming Language)",
          "Neo4j",
          "PostgreSQL",
          "FastAPI",
          "Kubernetes",
          "Continuous Integration and Continuous Delivery (CI/CD)",
          "Grafana",
          "ArgoCD",
        ],
        related_article: "Graphs (should be) everywhere",
      },
      {
        name: "BOIP Platform (Intrasoft)",
        duration: "Μαρ 2022 - Αυγ 2022",
        company: "Squaredev",
        description:
          "Συμμετοχή στο ευρωπαϊκό έργο BOIP, μια πλατφόρμα για την καταχώριση και προστασία δικαιωμάτων άλλων οργανισμών. Εστίαση στην ανάπτυξη frontend με χρήση Styled Components, Material UI και σχεδιαστικά mockups από Figma.",
        skills: ["React.js", "JavaScript", "TypeScript", "Material UI", "Figma", "Styled Components"],
      },
      {
        name: "Chatbot Widget",
        duration: "Ιουλ 2021 - Αυγ 2021",
        company: "Resitech LTD",
        description:
          "Ανάπτυξη ενός μικρού αλλά σύνθετου widget ερωτηματολογίων, πλήρως συμβατού με όλους τους σύγχρονους browsers. Υλοποιήθηκε με custom state management σε καθαρό JavaScript και αποθήκευση δεδομένων σε MongoDB, με πολλαπλά στάδια ροής και λογικής για τη διαχείριση χρηστών και απαντήσεων.",
        skills: ["JavaScript", "Node.js", "MongoDB"],
      },
      {
        name: "Web scraping",
        duration: "Μαϊ 2021 - Ιουν 2021",
        company: "Resitech LTD",
        description:
          "Υλοποίηση web scraping σε μεγάλη κλίμακα από ιστότοπους ακινήτων σε όλη την Ελλάδα, με στόχο τη δημιουργία βάσης δεδομένων για ανάλυση με τεχνικές machine learning. Το έργο περιλάμβανε σύνθετα και ετερογενή δεδομένα από πολλούς παρόχους, απαιτώντας ανθεκτικές και επεκτάσιμες στρατηγικές συλλογής.",
        skills: ["JavaScript", "Python (Programming Language)", "Node.js", "MongoDB"],
      },
      {
        name: "Resitech real estate platform",
        duration: "Μαρ 2021 - Μαϊ 2021",
        company: "Resitech LTD",
        description:
          "Ανάπτυξη της πλατφόρμας real estate της Resitech για την οπτικοποίηση δεδομένων της ΕΛΣΤΑΤ μέσω διαδραστικών γραφημάτων. Χρησιμοποιήθηκε Chart.js για την απεικόνιση σύνθετων δεδομένων με διαφορετικούς τύπους και γεωγραφικές περιοχές, δημιουργώντας ένα δυναμικό και καλά δομημένο UI.",
        skills: ["React.js", "JavaScript"],
      },
    ],
  },

  EN: {
    HEADER: "Welcome! I am glad you want to know me.",

    INTRO:
      "My name is Thergiakis Eftichios, I am a software engineer born and raised in the capital city Heraklion of Crete island where I also live. I consider myself a resourceful, self-motivated software engineer who is hard working and a quick learner. I am flexible as well as team oriented. I am currently seeking for a software engineer role where my existing qualifications will add value to the outset, whilst I continue to further develop my knowledge in the field as well as to expand further on the AI sector. More on",

    ABOUT_ME_TAG: "/about.",

    PROFILE:
      " I am a fullstack software engineer, ΑΙ enthusiast, sometimes a geek. I am quite humorous and I like people who smile and are open. Generally I love solving puzzles etc and I think programming is just that in a more elegant and professional level. Often get charmed by how a single line of code can affect someone's reality. Ι also like electronic music and I try to produce on my spare time.",

    WORK_EXP: [
      {
        title: "Younet",
        period: {
          text: "October 2025 - Present",
          date: {
            start: "10/25",
            end: "Present",
          },
        },
        hasRecLetter: false,
        description:
          "Designed, developed, and maintained multiple web applications and internal tools in a production environment, supporting diverse business needs and user flows. Took ownership of backend architecture, system integrations, and data management, with a strong focus on performance, reliability, and scalability. Worked on complex queries, data flows, and optimization of existing solutions, while actively contributing to the overall technical direction and evolution of the platform.",
      },
      {
        title: "Margera",
        period: {
          text: "Jan 2025 - July 2025",
          date: {
            start: "01/25",
            end: "06/25",
          },
        },
        hasRecLetter: true,
        description:
          "Developed a comprehensive AI-powered trend monitoring platform integrating LLMs, custom metrics, and data insights using technologies such as React, Django, SQL, and BigQuery. Involved in data warehousing and reporting processes, while maintaining large-scale ETL pipelines written in SQL. Designed and optimized complex queries and stored procedures for large-scale data extraction, analysis, and management.",
      },
      {
        title: "Squaredev",
        period: {
          text: "Mar 2022 - Jan 2025 · 2 yrs 11 mos",
          date: {
            start: "03/22",
            end: "01/25",
          },
        },
        hasRecLetter: false,
        description:
          "Worked as an external consultant at Intrasoft on BOIP, a rights registration platform for EU organizations, focusing primarily on frontend development. Played a key role in the full lifecycle of “Anty,” a recommendation system and flagship product at Squaredev. Contributed to the EU-funded Sunrise project on resource demand prediction for sectors like water and healthcare, covering everything from library development to deployments and Kubernetes. Also led development of an LLM penetration testing platform with AIandMe, involving technologies such as multithreading, websockets, relational databases, Azure deployments, and frontend work in Next.js.",
      },
      {
        title: "Resitech LTD",
        period: {
          text: "Arpil 2021 - March 2022 · 1 year",
          date: { start: "04/21", end: "03/22" },
        },
        hasRecLetter: false,
        description:
          "Involved in the development of Resitech platform for presenting NLP and real estate analytics data with technologies like React.js, Node.js, and Mongo DB as well as collecting data from Real Estate pages (web scraping). Additionally developed a small powerful interactive widget used to collect client feedback as well as problem reporting integrated in various platforms like e-shops.",
      },
    ],

    EDUCATION: "Heraklion TEI – Department of Applied Informatics and Multimedia (2013-2019)",

    SOFT_SKILLS: [
      "Analytical and problem solving abilities",
      "Performance optimization techniques",
      "Strong debugging skills",
      "Straight communication",
      "Eager to collaborate",
    ],

    LANG_ARRAY: ["Greek", "English", "Basic French and Italian"],

    CONTACT_PROMPT: "If I left anything out or you have further questions feel free to contact me.",

    DOWNLOAD_CV: "Download my CV",

    PINNED: {
      iamAI: {
        TITLE: "iamAI",
        DESCRIPTION: "A smart chatbot that can answer all sorts of questions, also available through an API.",
      },
    },
    AND: " and ",
    PROJECTS: [
      {
        name: "Nemeseas",
        duration: "February 2026 - Present",
        company: "Younet",
        description:
          "Designed and developed the backend of a full end-to-end restaurant booking system (Nemeseas), taking full ownership of both architecture and implementation. Built a scalable and reusable backend in Node.js (TypeScript), focusing on performance and developer experience. Implemented caching, mailing systems, schedulers, task queues, and advanced REST APIs. Integrated payment systems and supported frontend integration. Created a reusable backend boilerplate to improve team productivity and maintainability.",
        skills: [
          "Node.js",
          "TypeScript",
          "Architecture",
          "REST APIs",
          "Caching",
          "Task Queues",
          "Payments",
          "System Design",
        ],
      },
      {
        name: "Cloudo",
        duration: "March 2026",
        company: "Younet",
        description:
          "Contributed to the design and development of Cloudo, a private cloud file management system for the Orthodox Academy of Crete (OAC). Focused on secure storage and digital preservation of valuable archival material. Implemented file management features, access control, roles, and permissions, contributing to the digitization and organization of sensitive data.",
        skills: [
          "Full-Stack Development",
          "System Design",
          "Access Control",
          "File Management",
          "TypeScript",
          "Express",
          "Next.js",
        ],
      },
      {
        name: "CampusHub",
        duration: "February 2026",
        company: "Younet",
        description:
          "Contributed to the rapid development of the CampusHub internship platform, aiming to reduce bureaucracy between students and employers. Worked under strict deadlines, implementing new features and resolving critical issues across both frontend and backend. Helped stabilize the platform before delivery and improved overall user experience.",
        skills: ["Full-Stack Development", "React", "Node.js", "Bug Fixing", "Rapid Delivery", "Debugging"],
      },
      {
        name: "Idealink (University of West Attica Social Network)",
        duration: "October 2025 - February 2026",
        company: "Younet",
        description:
          "Worked on a large-scale social networking platform (Idealink) for the University of West Attica, focusing on performance optimization and scalability. Identified and resolved critical database bottlenecks, significantly improving system responsiveness. Optimized and extended existing backend components in a Node.js microservices architecture, introducing new features and redesigning critical parts such as the database driver to improve reusability and team efficiency. Also contributed to frontend bug fixing to enhance overall platform stability.",
        skills: ["Node.js", "Microservices", "Performance Optimization", "Database Tuning", "Refactoring", "Debugging"],
      },
      {
        name: "TV Attribution",
        duration: "July 2025 - July 2025",
        company: "Margera",
        description:
          "Implemented a system to target platform UI elements, extract their content into CSV files, and feed the data into Gemini for generating recommendations. Displayed recommendations via a dedicated icon in the UI and embedded them directly into the platform’s printable reports, enhancing client insights and usability.",
        skills: ["Python", "Google Cloud", "Gemini", "Data Extraction", "Prompt Engineering"],
      },
      {
        name: "Philip Morris International Consulting",
        duration: "Mar 2025 - Jul 2025",
        company: "Margera",
        description:
          "Worked on data warehousing and reporting, maintaining complex BigQuery and SQL-based ETL pipelines to automate data flows. Designed and optimized advanced queries and procedures for large-scale data extraction, analysis, and management.",
        skills: ["SQL", "BigQuery", "Google Cloud", "Proceedures"],
      },
      {
        name: "Culture Mapper (Publicis Groupe)",
        duration: "Jan 2025 - Mar 2025",
        company: "Margera",
        description:
          "Developed a trend monitoring platform using AI, LLMs, and embeddings for Publicis Groupe. Involved data scraping (e.g. TikTok, YouTube), clustering and analysis via embeddings, and automated summaries and metrics powered by LLMs. Built with React, Django, BigQuery, and complex SQL-based ETLs for scalable data processing.",
        skills: [
          "BigQuery",
          "Google Cloud",
          "OpenAI platform",
          "Embeddings",
          "SQL",
          "Django",
          "Python",
          "React",
          "Prompt Engineering",
        ],
      },
      {
        name: "AIandMe Platform",
        duration: "Sep 2024 - Jan 2025",
        company: "Squaredev",
        description:
          "Designed and built a custom LLM agent evaluation backend from scratch, enabling real-time prompt inspection before reaching the agent. Utilized SQL Server, CosmosDB, Azure Durable Functions, Azure Storage, and multithreading. Included a high-performance middleware layer to support live evaluation and fast decision-making at scale.",
        skills: [
          "Python (Programming Language)",
          "Microsoft SQL Server",
          "Microsoft Azure",
          "Multithreading",
          "Storage Management",
          "Azure Cosmos DB",
          "Azure Functions",
          "Azure Durable Functions",
          "Prompt Engineering",
        ],
      },
      {
        name: "AI Prognosis",
        duration: "Sep 2024 - Sep 2024",
        company: "Squaredev",
        description:
          "Developed a high-performance notification scheduler for the AI Prognosis project using Celery, enabling reliable and scalable delivery of time-sensitive updates to users. Designed for precision and efficiency to support consistent communication across a growing user base.",
        skills: ["Python (Programming Language)", "Celery"],
      },
      {
        name: "Sunrise EU",
        duration: "Nov 2023 - Sep 2024",
        company: "Squaredev",
        description:
          "Developed a multi-sector demand prediction tool to support public sector decision-making in resource management. Automated the deployment of various machine learning models tailored to different domains, enabling scalable and data-driven insights for areas such as water, healthcare, and energy.",
        skills: [
          "Python (Programming Language)",
          "ElasticSearch",
          "Keycloak",
          "MinIO Object Storage Suite",
          "Bash",
          "GitHub Actions",
          "Kubernetes",
          "Docker Products",
          "Continuous Integration and Continuous Delivery (CI/CD)",
          "ArgoCD",
        ],
        additional_info: "timepulse: A small library we made to integrate different models in the Sunrise project",
      },
      {
        name: "UpHellas",
        duration: "Jul 2023 - Jul 2023",
        company: "Squaredev",
        description:
          "Optimized the MLTool framework to efficiently solve a complex record linkage problem using parallel processing in Python. Focused on improving performance and scalability through multiprocessing techniques, enabling faster matching across large datasets.",
        skills: ["Parallel Processing", "Multithreading", "Python (Programming Language)", "Record Liknage"],
      },
      {
        name: "Anty",
        duration: "May 2022 - Jan 2023",
        company: "Squaredev",
        description:
          "Designed and deployed a high-performance, large-scale recommendation system supporting multiple e-pharmacies across different platforms. Engineered to handle high-concurrency traffic from various shops, the system delivers fast and personalized suggestions with seamless integration and scalable architecture.",
        skills: [
          "Python (Programming Language)",
          "Neo4j",
          "PostgreSQL",
          "FastAPI",
          "Kubernetes",
          "Continuous Integration and Continuous Delivery (CI/CD)",
          "Grafana",
          "ArgoCD",
        ],
        related_article: "Graphs (should be) everywhere",
      },
      {
        name: "BOIP Platform (Intrasoft)",
        duration: "Mar 2022 - Aug 2022",
        company: "Squaredev",
        description:
          "Worked on the EU-funded BOIP project, a platform for the registration and protection of rights for other organizations. Focused on frontend development using Styled Components, Material UI, and designs provided via Figma.",
        skills: ["React.js", "JavaScript", "TypeScript", "Material UI", "Figma", "Styled Components"],
      },
      {
        name: "Chatbot Widget",
        duration: "Jul 2021 - Aug 2021",
        company: "Resitech LTD",
        description:
          "Developed a lightweight yet complex browser-compatible survey widget, designed to work seamlessly across all modern browsers. Built with custom plain JavaScript state management and backed by MongoDB, the project involved multiple layers of logic for user flow and data handling.",
        skills: ["JavaScript", "Node.js"],
      },
      {
        name: "Web scraping",
        duration: "May 2021 - Jun 2021",
        company: "Resitech LTD",
        description:
          "Performed large-scale web scraping of real estate platforms across Greece to build a comprehensive database for machine learning analysis. The project involved handling complex and heterogeneous data from multiple property providers, requiring scalable and robust scraping strategies.",
        skills: ["JavaScript", "Python (Programming Language)", "Node.js", "MongoDB"],
      },
      {
        name: "Resitech real estate platform",
        duration: "Mar 2021 - May 2021",
        company: "Resitech LTD",
        description:
          "Developed Resitech's real estate platform for visualizing ELSTAT data through interactive charts. Used Chart.js to present complex datasets covering multiple data types and geographical regions, resulting in a dynamic and highly structured UI.",
        skills: ["React.js", "JavaScript", "Charts.js"],
      },
    ],
  },
};

export const tags = {
  GR: {
    aboutMe: {
      profile: "Προφίλ",
      experience: "Εργασιακή εμπειρία",
      skills: "Δεξιότητες και τεχνογνωσία",
      education: "Εκπαίδευση",
      books: "Βιβλία",
      languages: "Γλώσσες",
    },
    experience: {
      recent: "Πρόσφατα πρότζεκτς",
      buttons: {
        viewAPI: "API",
        viewRepo: "Github",
        viewClient: "Client",
        visitApp: "App",
      },
      pinned: "Επιφανή",
    },
    navbar: {
      home: "Αρχική",
      experience: "Εμπειρία",
      aboutMe: "Σχετικά με εμένα",
      contact: "Επικοινωνήστε",
    },
  },

  EN: {
    aboutMe: {
      profile: "Profile",
      experience: "Work Experience",
      skills: "Skills & Knowledge",
      education: "Education",
      books: "Βooks",
      languages: "Languages",
    },
    experience: {
      recent: "Recent projects",
      buttons: {
        viewAPI: "API",
        viewRepo: "Github",
        viewClient: "Client",
        visitApp: "App",
      },
      pinned: "Pinned",
    },
    navbar: {
      home: "Home",
      experience: "Experience",
      aboutMe: "About Me",
      contact: "Contact",
    },
  },
};
